import { StepType } from "src/app/data-types/flow-management/model/step-type";
import { ClosurePath } from "./closure-path";
import { FlowType } from "./flow-type";

export class DrawFlowFullData {
    ft: FlowType;
    closures: ClosurePath[] = [];
    drawFlowData: DrawFlowDto;
}

export class DrawFlowDto {
    data: Record<string, DrawFlowNode>
}

export class DrawFlowNode {
    id: string;
    name: string;
    data: StepType;
    class: string = 'dbclick';
    html: string = '';
    typenode: boolean = false;
    inputs: Record<string, { connections: { node: number; input: string, labels: string[] }[] }> = {};
    outputs: Record<string, { connections: { node: number; output: string, labels: string[] }[] }> = {};
    pos_x: number = 0;
    pos_y: number = 0;

}
